import React from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Oval } from "react-loader-spinner";
import toast from "react-hot-toast";

import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import { dumpsterSizeToAllowedWeight, Order } from "../../../../models";
import {
  createWeightOverageInvoice,
  resetCreateWeighOverageInvoice,
  setShowAddInvoiceModal,
} from "../../ordersSlice";

import "./WeightOverageInvoiceForm.scss";
import { RadioButton } from "../../../Shared";

export interface WeightOverageInvoiceFormModel {
  allowedWeight: string;
  dumpedWeight: string;
}

const validationSchema = Yup.object().shape({
  allowedWeight: Yup.number().positive(),
  dumpedWeight: Yup.number().positive(),
});

export interface WeightOverageInvoiceFormProps {
  order: Order;
}

export function WeightOverageInvoiceForm(props: WeightOverageInvoiceFormProps) {
  const dispatch = useAppDispatch();
  const { order } = props;

  const createWeightOverageInvoiceAPI = useAppSelector(
    (state) => state.orders.createWeightOverageInvoiceAPI
  );

  React.useEffect(() => {
    if (
      !createWeightOverageInvoiceAPI.loading &&
      !!createWeightOverageInvoiceAPI.error
    ) {
      toast.error("Something went wrong. Please try again.");
    }

    if (
      !createWeightOverageInvoiceAPI.loading &&
      !createWeightOverageInvoiceAPI.error &&
      createWeightOverageInvoiceAPI.value
    ) {
      toast.success("Successfully created invovice.");
      dispatch(setShowAddInvoiceModal(undefined));
      dispatch(resetCreateWeighOverageInvoice());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    createWeightOverageInvoiceAPI.loading,
    !!createWeightOverageInvoiceAPI.error,
    !!createWeightOverageInvoiceAPI.value,
  ]);

  const initialValues: WeightOverageInvoiceFormModel = {
    allowedWeight: order.dumpsterSize
      ? dumpsterSizeToAllowedWeight[order.dumpsterSize] + ""
      : "4000",
    dumpedWeight: "",
  };

  const onSubmit = (form: WeightOverageInvoiceFormModel) => {
    if (createWeightOverageInvoiceAPI.loading) return;

    dispatch(
      createWeightOverageInvoice({
        orderId: order.id,
        form,
      })
    );
  };

  return (
    <div className="weight-overage-invoice-form-component">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ errors, touched }) => (
          <Form className="weight-overage-form">
            <div className="field-container">
              <div className="label">Allowed Weight:</div>
              <div className="row">
                <RadioButton
                  name="allowedWeight"
                  value="4000"
                  label="4000 lbs"
                />
                <RadioButton
                  name="allowedWeight"
                  value="6000"
                  label="6000 lbs"
                />
              </div>
            </div>

            <div className="field-container">
              <div className="label">Dumped Weight:</div>
              <Field
                id="dumpedWeight"
                name="dumpedWeight"
                className="text-input"
              />
              {errors.dumpedWeight && touched.dumpedWeight && (
                <div className="form-error">{errors.dumpedWeight}</div>
              )}
            </div>

            <button
              type="submit"
              className="add-button"
              disabled={createWeightOverageInvoiceAPI.loading}
            >
              Create Invoice
              {createWeightOverageInvoiceAPI.loading && (
                <div style={{ marginLeft: 8 }}>
                  <Oval
                    color="#131313"
                    height={20}
                    width={20}
                    secondaryColor="#FBD20A"
                  />
                </div>
              )}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}
